import React from 'react';
import Logo from '../../assets/images/logo.svg';
import { Container, Typography, useMediaQuery } from '@mui/material';
import { CustomColors, theme } from '../../theme';
import NoAssetFound from '../../assets/images/no-asset.svg';

const RegisterAssetSuccess: React.FC = () => {
  const isSmallScreen = useMediaQuery(
    '(max-width: 900px) and (min-width: 520px)'
  );
  const isMobile = useMediaQuery('(max-width: 520px)');

  const styles: { [key: string]: React.CSSProperties } = {
    h1: {
      fontSize: theme.spacing(5),
      lineHeight: theme.spacing(5),
      fontWeight: 500,
      marginLeft: isSmallScreen ? 0 : isMobile ? 0 : '100px',
      width: isSmallScreen ? '50%' : '100%',
      color: CustomColors.foregroundColor,
    },
    p: {
      width: isSmallScreen ? '50%' : '100%',
      marginTop: 3,
      marginLeft: isSmallScreen ? 0 : isMobile ? 0 : '100px',
      color: CustomColors.grey,
    },

    container: {
      marginTop: theme.spacing(8),
      padding: theme.spacing(5),
    },
    mainContainer: {
      padding: isSmallScreen ? '50px' : 0,
    },
    signUpContainer: {
      marginTop: isSmallScreen ? 0 : isMobile ? 0 : theme.spacing(8),
      paddingRight: isSmallScreen ? 0 : isMobile ? 0 : '150px',
    },
    logo: {
      width: theme.spacing(20),
      marginTop: theme.spacing(5),
      marginBottom: theme.spacing(5),
    },
    button: {
      marginTop: theme.spacing(5),
    },
  };

  return (
    <div>
      <Container maxWidth="xl">
        <img src={Logo} alt="BlueSana" style={styles.logo} />

        <Container
          maxWidth="xl"
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            minHeight: '80vh',
            width: !isSmallScreen ? '480px' : '100%',
            textAlign: 'center',
          }}
        >
          <div>
            <img src={NoAssetFound} alt="Not Approved" />
          </div>
          <Typography variant="h4">Thank you.</Typography>

          <Typography color="grey" marginTop={2}>
            Thank you for registering your interest. We will be in contact when
            we have reviewed your response. If you have any questions, please
            reach out to{' '}
            <a href="mailto:contact@bluesana.com.au">contact@bluesana.com.au</a>
          </Typography>
        </Container>
      </Container>
    </div>
  );
};

export default RegisterAssetSuccess;
